export default __webpack_public_path__ + "static/media/download.adb28a73.svg";